import { useMemo } from "react";
import { useSelector } from "../../redux/hooks";
interface Props {
  readonly: boolean | undefined;
  grayed: boolean | undefined;
}
/**
 * Custom hook to generate a CSS class name based on readonly and grayed properties.
 *
 * @param props - An object containing the following properties:
 *   - readonly: A boolean indicating if the element is readonly.
 *   - grayed: A boolean indicating if the element is grayed out.
 * @returns A string representing the CSS class name for the element.
 */
const useReadonlyClass = ({ readonly, grayed }: Props) => {
  const { theme, isDarkMode } = useSelector(state => state.preferencesSlice);

  return useMemo(
    () =>
      readonly && !grayed
        ? `${theme === "DSNM" ? "DSNM-" : ""}${isDarkMode ? "readonly-dark" : "readonly"}`
        : "",
    [readonly, isDarkMode, grayed],
  );
};
export default useReadonlyClass;
